module.exports = __webpack_public_path__ + "img/type3_check_2.0c800818.png";